import { render, staticRenderFns } from "./ButtonCheck.vue?vue&type=template&id=0a621d36&scoped=true&"
import script from "./ButtonCheck.vue?vue&type=script&lang=js&"
export * from "./ButtonCheck.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCheck.vue?vue&type=style&index=0&id=0a621d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a621d36",
  null
  
)

export default component.exports